<template>
  <div class="home">
    <!-- <h1>钱坤智投</h1> -->
    <!-- <p>欢迎访问钱坤智投官方网站</p>
    <div class="links">
      <router-link to="/user-agreement" class="btn">查看用户协议</router-link>
      <router-link to="/privacy-policy" class="btn">查看隐私政策</router-link> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.home {
  padding: 40px 20px;
  text-align: center;
}

h1 {
  font-size: 42px;
  margin-bottom: 20px;
  color: #333;
}

p {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

.links {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn {
  display: inline-block;
  background-color: #42b983;
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s;
}

.btn:hover {
  background-color: #3aa876;
}
</style> 